<template>
  <keep-alive include="VideoList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Video",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
